import { MdDescription } from "react-icons/md";
import { Spec } from "../../models/specs";

type SpecCardProps = {
    spec: Spec;
    onView: (spec: Spec) => void;
    isAdmin?: boolean;
};
const allowedTypes = new Set([
    "Direct Post",
    "Ping Post",
    "RTB",
    "Availability Ping",
    "N/A"
]);



export function SpecCard({ spec, onView, isAdmin = false }: SpecCardProps) {
    const rawType = spec.type ?? "";
    const safeType = allowedTypes.has(rawType) ? rawType : "N/A";

    return (
        <div
            className="bg-white rounded-2xl shadow hover:shadow-lg transition p-5 flex items-center justify-between"
        >
            <div className="flex flex-row gap-2 min-w-36">
                <span className="p-2 rounded-lg text-sm font-semibold uppercase text-[#F97316] bg-orange-50">
                    {spec.product[0]}
                </span>
                <span className="p-2 rounded-lg text-sm font-semibold uppercase text-[#F97316] bg-orange-50">
                    {safeType}
                </span>
                <span className="p-2 rounded-lg text-sm font-semibold uppercase text-[#F97316] bg-orange-50">
                    {spec.vertical}
                </span>
            </div>

            <h2 className="text-xl font-bold text-left text-[#3f3f3f] truncate flex-1 ml-8">
                {spec.unique_id}
            </h2>

            <button
                onClick={() => onView(spec)}
                className="ml-4 px-6 py-3 rounded-2xl bg-orange-500 hover:bg-orange-600 text-white font-bold text-lg transition flex items-center justify-center"
                title="View Documentation"
            >
                <MdDescription size={28} className="mr-2" />
                View
            </button>
        </div>
    );

}
